import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';

import connection from '../../extensions/scratch3_reachy/connection.js';
import styles from './reachy-status.css';

/**
 * Indikátor stavu robota v hornej lište.
 *
 * Zobrazuje sa len vtedy, keď je rozšírenie Reachy Mini pridané do projektu —
 * inak by mátalo deti, ktoré s robotom nič nerobia. Stav si berie priamo zo
 * singletonu spojenia, takže o VM nemusí nič vedieť.
 */
class ReachyStatus extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            pripojeny: connection.isRobotReady(),
            zobrazit: this._maRozsirenie(props.vm)
        };
        this._odhlas = null;
        this._casovac = null;
    }

    componentDidMount () {
        this._odhlas = connection.subscribe(pripojeny => this.setState({pripojeny}));
        // Rozšírenie sa dá pridať kedykoľvek (aj načítaním projektu), preto sa
        // na to raz za sekundu pozrieme - lacnejšie než sa vešať na VM.
        this._casovac = setInterval(() => {
            const zobrazit = this._maRozsirenie(this.props.vm);
            if (zobrazit !== this.state.zobrazit) this.setState({zobrazit});
        }, 1000);
    }

    componentWillUnmount () {
        if (this._odhlas) this._odhlas();
        if (this._casovac) clearInterval(this._casovac);
    }

    _maRozsirenie (vm) {
        return !!(vm && vm.extensionManager && vm.extensionManager.isExtensionLoaded('reachyBlocks'));
    }

    render () {
        if (!this.state.zobrazit) return null;
        const {pripojeny} = this.state;
        return (
            <div
                className={classNames(styles.reachyStatus, {
                    [styles.pripojeny]: pripojeny
                })}
            >
                <span className={styles.bodka} />
                <span className={styles.text}>
                    {pripojeny ? (
                        <FormattedMessage
                            defaultMessage="Robot pripojený"
                            description="Menu bar label when the Reachy robot is connected"
                            id="gui.reachy.connected"
                        />
                    ) : (
                        <FormattedMessage
                            defaultMessage="Robot nie je pripojený"
                            description="Menu bar label when the Reachy robot is not connected"
                            id="gui.reachy.disconnected"
                        />
                    )}
                </span>
            </div>
        );
    }
}

ReachyStatus.propTypes = {
    vm: PropTypes.shape({
        extensionManager: PropTypes.shape({
            isExtensionLoaded: PropTypes.func
        })
    })
};

export default ReachyStatus;
